/**
 * MessageDisabledIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const MessageDisabledIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M4.2 18.83a1 1 0 1 0 1.42 1.41l3.19-3.19h.05l1.78 3.55a1.44 1.44 0 0 0 2.68 0l1.78-3.55h.88a7 7 0 0 0 4.85-12l.34-.34a1 1 0 1 0-1.41-1.42zm11.78-3.78h-2.12l-1.88 3.76-1.65-3.29 9.09-9.08a5 5 0 0 1-3.44 8.61M5.7 14.5a5 5 0 0 1 2.28-9.45h7.17l1.91-1.91a8 8 0 0 0-1.08-.09h-8a7 7 0 0 0-3.73 12.91z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const MessageDisabledIcon = makeIcon('MessageDisabledIcon', MessageDisabledIconSvg)
